
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import WaterWorkMasterPagePopup from './WorkMasterPagePopup'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import { useSearchParams } from 'react-router-dom'
import { WaterSupplyWorkTypeDataDDL } from '../../../../../../Components/CommonDDL/WaterSupplyWorkTypeDataDDL'
import { WaterSupplyWorkNameDataDDL } from '../../../../../../Components/CommonDDL/WaterSupplyWorkNameDataDDL'
import { useAuthState } from '../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { WaterSupplyPipelineExportTableDataAPI, WaterSupplyPipelineTableDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/WaterSupplyMasterSlice/WaterSupplyPipelineSlice'
import { WaterSupplyWorkNameExportTableDataAPI, WaterSupplyWorkNameMasterDeleteAPI, WaterSupplyWorkNameTableDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/WaterSupplyMasterSlice/WaterSupplyWorkNameSlice'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import { Loading } from '../../../../../../Helper/Loading'
import { WorkMasterPageExportData } from './WorkMasterPageExportData'


export default function WorkMasterPage() {

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [WaterWorkMasterPopupShow, setWaterWorkMasterPopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [CurrentPage, setCurrentPage] = useState(0)
    const [PerPageCount, setPerPageCount] = useState(10)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [rowNo, setrowNo] = useState(1)
    const [FromTop, setFromTop] = useState(1)
    const [ToTop, setToTop] = useState(10)

    const [isSearch, setIsSearch] = useState(false)

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")

    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")

    // console.log(DashProjectTypeId)

    const [WSWorkType, setWSWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WSWorkName, setWSWorkName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setWaterWorkMasterPopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setWaterWorkMasterPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }
    const handleOnCloseClick = () => {
        setWaterWorkMasterPopupShow(false)
    }
    const handleClear = () => {
        setToTop(10)
        setFromTop(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setWSWorkType({
            ...WSWorkType,
            ID: 0,
            Label: 'Select...',
        })
        setWSWorkName({
            ...WSWorkName,
            ID: 0,
            Label: 'Select...',
        })
    }

    useEffect(() => {
        const data = {
            M_Distri_WorkNameID: WSWorkName.ID,
            M_Distri_WorkTypeID: WSWorkType.ID,
            M_Distri_WorkPeriodID: 0,
            WorkName: '',
            token: token,
            From: FromTop,
            To: ToTop,
            M_UserID: UserID,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID,
            handleWaterSupplyWorkNameExport:handleWaterSupplyWorkNameExport
        }
        // if (WardName.ID !== 0) {
        dispatch(WaterSupplyWorkNameTableDataAPI({ data }))
        // }
    }, [IsPost, FromTop, IsClear, isSearch])

    const { tableData, isLoading } = useSelector(state => state.WaterSupplyWorkNameTableData)

    const handleSearch = () => {
        setCurrentPage(0)
        setToTop(10)
        setFromTop(1)
        setIsSearch(!isSearch)
    }

    const handleWaterSupplyWorkNameExport = () => {
        const data = {
            M_Distri_WorkNameID: WSWorkName.ID,
            M_Distri_WorkTypeID: WSWorkType.ID,
            M_Distri_WorkPeriodID: 0,
            WorkName: '',
            token: token,
            From: '1',
            To: '99999',
            M_UserID: UserID,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }
        // if (WardName.ID !== 0) {
        dispatch(WaterSupplyWorkNameExportTableDataAPI({ data }))
        // }
    }
    // , [IsPost, isSearch, IsClear])

    const { ExportTableData, isExportLoading } = useSelector(state => state.WaterSupplyWorkNameExportTableData)

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleDeleteApi = (item) => {
        const data = {
            M_Distri_WorkNameID: item.m_Distri_WorkNameID,
            M_WS_WorkNameID: item.m_wS_WorkNameID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }
        dispatch(WaterSupplyWorkNameMasterDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.WaterSupplyWorkNameMasterDeleteData)

    return (
        <div>
            {isLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName}
            />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />
                <div className="content">
                    {/* <!-- [ breadcrumb ] start --> */}
                    <div className="page-header ">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">

                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- [ Main Content ] start --> */}
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='col-5'>
                                <h5 className="mt-2">Work Master</h5>
                            </div>
                            <div className='col-7 mar_add'>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <WorkMasterPageExportData
                                                ExcelData={ExportTableData}
                                                name='Work Master'
                                                RoleID={RoleID}
                                            // searchName={searchName}
                                            />
                                    }
                                    <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                        style={{ color: "white" }}
                                        onClick={handleAddOnClick}
                                    >
                                        <text className="ml-2 poppins">Add</text>
                                    </i>
                                </div>
                            </div>
                            <div className="row m-0 ">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">
                                            <div className="col-lg-3 col-md-4">
                                                <WaterSupplyWorkTypeDataDDL
                                                    WSWorkType={WSWorkType}
                                                    setWSWorkType={setWSWorkType}
                                                    DashProjectTypeId={DashProjectTypeId}
                                                />

                                            </div>
                                            <div className="col-lg-3 col-md-4">
                                                <WaterSupplyWorkNameDataDDL
                                                    WSWorkName={WSWorkName}
                                                    setWSWorkName={setWSWorkName}
                                                    WSWorkType={WSWorkType}
                                                    DashProjectTypeId={DashProjectTypeId}
                                                />
                                            </div>
                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-1">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Work Type</th>
                                                        <th>Work Period</th>
                                                        <th>Work Code</th>
                                                        <th>Work Name</th>
                                                        <th>Penalty Period</th>
                                                        <th>Bench Mark</th>
                                                        <th>Penalty Description</th>
                                                        <th>Penalty Amount (Rs.)</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) =>
                                                            <tr>
                                                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td>{item.workType ? item.workType : '-'}</td>
                                                                <td>{item.parameterDescription ? item.parameterDescription : '-'}</td>
                                                                <td>{item.workCode ? item.workCode : '-'}</td>
                                                                <td>{item.workName ? item.workName : '-'}</td>
                                                                <td>{item.penaltyPeriod ? item.penaltyPeriod : '-'}</td>
                                                                <td>{item.benchMark ? item.benchMark : '-'}</td>
                                                                <td>{item.penalty_Description ? item.penalty_Description : '-'}</td>
                                                                <td>{item.penalty_Values ? item.penalty_Values : '-'}</td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    <span>
                                                                        <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleEditOnClick(item)}
                                                                        >
                                                                        </i>
                                                                    </span>
                                                                    <span>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) :
                                                            <td colSpan={15}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFromTop}
                                                setTo={setToTop}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    WaterWorkMasterPopupShow ?
                        <WaterWorkMasterPagePopup
                            open={WaterWorkMasterPopupShow}
                            popupHeading="Pipe Line"
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                            DashProjectTypeId={DashProjectTypeId}
                            RoleID={RoleID}
                        />
                        : <></>
                }
            </div>
        </div>



    )
}